import React from 'react';
import { HOCs } from '@pearsontechnology/aero-components';

import KnowledgeMapDownloadButton from './KnowledgeMapDownloadButton';
import KnowledgeMapDownloadMenu from './KnowledgeMapDownloadMenu';

const { enhanceWithPopper } = HOCs;
const ButtonWithPopper = enhanceWithPopper(KnowledgeMapDownloadButton);

const KnowledgeMapDownload = (props) => (
  <ButtonWithPopper placement="bottom-end" hidepopperonclick>
    <KnowledgeMapDownloadMenu {...props} />
  </ButtonWithPopper>
);

export default KnowledgeMapDownload;
